<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex md12 lg12 xs12 sm12>
        <h4 class="pull">Entrevistas Externa</h4>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex md10 lg10 xs12 sm11>
        <carousel :per-page="3" :mouse-drag="true">
          <slide v-for="(persona,index) in personas" :key="index">
            <v-card class="mx-auto" color="#273039" dark max-width="400">
              <v-card-title>
                <span class="title font-weight-light">{{persona.cargo}}</span>
              </v-card-title>
              <v-layout align-center >
              <v-card-text class="fontSize">{{persona.resumen}}</v-card-text>
              </v-layout>
              <v-card-actions>
                <v-list-tile class="grow">
                  <v-list-tile-avatar color="grey darken-3">
                    <v-img class="elevation-6" :src="img[index]"></v-img>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>{{persona.nombre}}</v-list-tile-title>
                  </v-list-tile-content>

                  <v-layout align-center justify-end>
                    <v-btn icon>
                      <v-icon @click="changeDialog(persona,img[index])">bookmark</v-icon>
                    </v-btn>
                  </v-layout>
                </v-list-tile>
              </v-card-actions>
            </v-card>
          </slide>
        </carousel>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-dialog class="dialog-card" v-model="dialog" width="700px">
        <template v-slot:activator="{ on }"></template>
        <v-card class="dialog-card">
          <v-layout>
            <v-flex xs5 md5 lg5 sm5>
              <v-img class="image" :src="imgtest"></v-img>
            </v-flex>
            <v-flex xs7 md7 lg7 sm7>
              <v-layout>
                <v-flex xs12 md12 lg12 sm12>
                  <v-card class="card-small">
                    <v-layout align-center justify-center fill-height>
                      <p>"{{entrevista}}"</p>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 md12 lg12 sm12>
                  <v-card class="card-small2">
                    <v-layout align-center justify-end fill-height>
                      <p style="color:white!important;">{{nombre}}</p>
                      <v-btn icon>
                      <v-icon @click="downloadFile(persona)">play_for_work</v-icon>
                    </v-btn>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout></v-layout>
  </v-container>
</template>

<script>
import img1 from "../../assets/Captura2.png";
import img2 from "../../assets/Katherine.jpg";
import img3 from "../../assets/Karla.jpg";
import img4 from "../../assets/Alejandra.jpg";
import img5 from "../../assets/mujer.png";
import { Carousel, Slide } from "vue-carousel";

export default {
  data() {
    return {
      dialog: false,
      img1: img1,
      img2: img2,
      img3: img3,
      img4: img4,
      img5: img5,
      img: [img2,img3,img4],
      imgtest: "",
      nombre: "",
      entrevista: "",
      right: null,
      personas: "",
      persona: "",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      }
    };
  },

  components: {
    Carousel,
    Slide
  },

  mounted() {},

  created() {
    axios
      .get(process.env.ROOT_API + "/entrevista/getAll", this.auth)
      .then(response => {
        //console.log(response.data);
        this.personas = response.data;
      })
      .catch(console.error);
  },

  methods: {
    changeDialog(persona, img) {
      this.dialog = true;
      this.nombre = persona.nombre;
      this.entrevista = persona.caracterizacion;
      this.persona = persona
      this.imgtest = img;
    },

    downloadFile(persona) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(persona.archivo);
      var nameFile = persona.nombre;
      //console.log(nameFile);
      if (pathFile != "") {
      axios
        .get(
          process.env.ROOT_API+"/uploadFileDcaEtc/downloadFile?dir=" + pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
      }
      else{
        alert("Contenido no disponible")
      }
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }
  
};
</script>


<style scoped>
#chartdiv2 {
  width: 100% !important;
  height: 300px !important;
}

.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 50px !important;
}

.v-card-new {
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #fafafa;
  height: 400px !important;
  overflow-y: auto;
}

.v-card {
  height: 350px;
  overflow-y: auto;
}
.image {
  height: 350px !important;
}

.fontSize{
  font-size: 18px!important;
}

.td-color {
  background: #394049;
  height: 100%;
}

.card-small {
  height: 300px !important;
  background-color: #b1b1b1 !important;
  border-radius: 0% !important;
  text-align: justify !important;
  padding-left: 5% !important;
  padding-right: 5% !important;
  font-style: italic;
  margin: 0% !important;
}

.card-small2 {
  height: 50px !important;
  background-color: #394049 !important;
  border-radius: 0% !important;
  text-align: justify !important;
  padding: 3% !important;
  margin: 0% !important;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 200px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 11px;
}

.dialog-card {
  border-radius: 3% !important;
  margin: 0% !important;
  padding: 0% !important;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

#chartdiv {
  width: 100%;
  height: 300px;
}

.mx-auto {
  border-radius: 10% !important;
  margin-left: 5px !important;
  margin-right: 5px !important;
  height: 380px!important;
}
</style>

<style>
.VueCarousel-dot {
  background-color: #ec6a12 !important;
  outline: none !important;
}
.VueCarousel-dot--active {
  background-color: #273039 !important;
  outline: "none" !important;
}
</style>




// WEBPACK FOOTER //
// src/components/diagnosticoEstrategico/EntrevistaExterna.vue